// The derived payment mode of an order (paymentMode.mjs): one neutral chip + the rule as tooltip. Same words on the Sales Orders list, the
// order page header and the 👁 order preview.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatMoneyExact } from '../../utils/format';
import { paymentMode } from './paymentMode.mjs';

export function paymentModeText(o, t) {
  const m = paymentMode(o);
  if (m.key === 'credit') return m.days == null ? t('pm_credit_noterms') : t('pm_credit', { n: m.days });
  if ((m.key === 'prepaid' || m.key === 'part_prepaid') && m.paid != null) return t(`pm_${m.key}_amt`, { paid: formatMoneyExact(m.paid), of: formatMoneyExact(m.of) });
  return t(`pm_${m.key}`);
}
export default function PaymentModeChip({ o, style }) {
  const { t } = useTranslation('invoicing');
  if (!o || !o.payment_method) return null;
  const m = paymentMode(o);
  return <span className={`chip ${m.key === 'cash' ? 'good' : m.key === 'credit' ? 'mut' : 'info'}`} title={t(`pmRule_${m.key}`)} data-testid="payment-mode" data-mode={m.key} style={style}>{paymentModeText(o, t)}</span>;
}
